import { EventHandler } from "react";
import { UseQueryResult } from "react-query";
import { getErrorMessage } from "shared/utils/network";
import PublicApi from "../../../../shared/enums/PublicApi";
import { useGetApiData } from "shared/datalayer";

export function useGetCaptcha(onSuccessHandler: EventHandler<any>): UseQueryResult<CaptchaResponseType> {
  return useGetApiData<CaptchaResponseType>(PublicApi.CAPTCHA, undefined, {
    onSuccess: data => onSuccessHandler(data),
    onError: err => getErrorMessage(err)
  });
}
